import Cookies from 'js-cookie';
import jwt, { JwtPayload } from 'jsonwebtoken';
import { makeAutoObservable, computed, action } from 'mobx';
import { TOKEN_KEY } from '../constants';
import { azureADLogin, azureADLogout } from '../services/AuthService';
import { RootStore } from './RootStore';

export class AuthStore {
  constructor(private rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  validateToken = () => {
    const decodedToken = this.decodeToken();
    if (!decodedToken) {
      return false;
    }
    const { exp } = decodedToken.payload as JwtPayload;
    if (!exp) return false;
    const expiration = new Date(exp * 1000);
    const now = new Date();
    return expiration > now;
  };

  @computed
  get getToken() {
    return Cookies.get(TOKEN_KEY) || '';
  }

  @action
  logoutUser = async () => {
    localStorage.clear();
    Cookies.remove(TOKEN_KEY);
  };

  @action
  azureADLoginHandler = () => {
    this.rootStore.spinnerStore.manageSpinnersHandler(azureADLogin);
  };

  @action
  azureADLogoutHandler = async () => {
    await this.rootStore.spinnerStore.manageSpinnersHandler(azureADLogout);
  };

  decodeToken = () => {
    try {
      return jwt.decode(this.getToken.replace('Bearer ', ''), { complete: true });
    } catch {
      return null;
    }
  };
}
